export default __webpack_public_path__ + "static/media/teaser_keran_final.c7230ca7.mp4";